const React = require('react')
const PropTypes = require('prop-types')
const log = require('log').create('profile prompt') // eslint-disable-line

class ProfilePrompt extends React.Component {

    constructor() {
        super()
        this.state = {}
    }

    componentDidMount() {
        if (this.props.mapped) return

        require.ensure([], () => {
            const AnonymousPrompt = require('./anonymous_prompt')
            this.setState({
                AnonymousPrompt,
            })
        }, 'profile_prompt')
    }

    render() {
        // don't render on mapped domains
        if (this.props.mapped) return null

        // get our components from state, which are lazy-loaded in componentDidMount
        const {
            AnonymousPrompt,
        } = this.state

        // don't render if not mounted yet
        if (! AnonymousPrompt) return null

        return (
            <AnonymousPrompt {...this.props} />
        )
    }

}

ProfilePrompt.propTypes = {
    mapped: PropTypes.bool.isRequired,
}

module.exports = ProfilePrompt
